import React from 'react'

function Related(props) {
  return (
    <div className='filterdropdown '>
            <select className={props.className || "border  p-2 rounded-md lg:w-[200px] md:w-[146px] h-[40px] w-[120px]  "}>
              <option value="Select Location">{ props.option }</option>
            </select>
      </div>
  )
}

export default Related